import { licenseCheckLatestStatusEntityName } from '../../../../backend/features/credentialing-verification/shared';
import { mapLicenseCheckLatestStatusFilter } from './mapLicenseCheckLatestStatusFilter';
export function mapLicenseCheckLatestStatusToAccountFilter(userState, filterData, expiringOnlyFilter, accountFilter) {
    const filter = [
        ...accountFilter,
        {
            column: 'systemStatus',
            op: '=',
            value: 'active',
        },
    ];
    const licenseCheckLatestStatusFilter = mapLicenseCheckLatestStatusFilter(userState, filterData, expiringOnlyFilter);
    if (licenseCheckLatestStatusFilter.length > 0) {
        filter.push({
            op: 'in',
            idSubFilter: {
                entity: licenseCheckLatestStatusEntityName,
                column: 'personId',
                filter: licenseCheckLatestStatusFilter,
            },
        });
    }
    return filter;
}
